
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-chauffeur",
      function () {
        return require("private-next-pages/personal-chauffeur/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal-chauffeur"])
      });
    }
  